import React from 'react';
import './css/CreateEventSkeletonLoader.css';

// this component displays a skeleton loader for the Create Event page.
function CreateEventSkeletonLoader() {
  return (
    <div className="skeleton-loader-overlay">
      <div className="skeleton-loader">
        <div className="skeleton-input"></div>
        <div className="skeleton-select"></div>
        <div className="skeleton-button"></div>
        <div className="skeleton-list">
          {Array(3)
            .fill(0)
            .map((_, index) => (
              <div className="skeleton-list-item" key={index}></div>
            ))}
        </div>
        <div className="skeleton-header"></div>
        <div className="skeleton-input"></div>
        <div className="skeleton-select"></div>
        <div className="skeleton-button"></div>
        <div className="skeleton-list">
          {Array(3)
            .fill(0)
            .map((_, index) => (
              <div className="skeleton-list-item" key={index}></div>
            ))}
        </div>
        <div className="skeleton-date"></div>
        <div className="button-group">
          <div className="skeleton-button"></div>
          <div className="skeleton-button"></div>
        </div>
      </div>
    </div>
  );
}

export default CreateEventSkeletonLoader;